import { ExtensionOption } from 'src/app/pages/extension-register/models/extension-option.interface';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../../select/eager-select/eager-select-reducer';
import { filterExtensionOption } from '../../../select/shared/filter-extension-option';
import { extensionLoadQueuesActions } from '../extension-option.actions';

export const extensionQueueOptionFeatureKey = 'extensionQueueOptions';

export type ExtensionQueuesOptionState = EagerSelectState<ExtensionOption>;

const queueAdapter = createEagerSelectAdapter<ExtensionQueuesOptionState, ExtensionOption>({
   featureKey: extensionQueueOptionFeatureKey,
   selectId: (extension: ExtensionOption) => {
      return extension.extensionId;
   },
});

export const extensionQueueOptionSelectors = queueAdapter.getSelectors(filterExtensionOption);

const initialQueueState = queueAdapter.getInitialState();

export const extensionQueueOptionsReducer = createEagerSelectReducer(
   queueAdapter,
   initialQueueState,
   extensionLoadQueuesActions.search,
   extensionLoadQueuesActions.searchReset,
   extensionLoadQueuesActions.loadFromApi,
   extensionLoadQueuesActions.loadFromApiSuccess,
   extensionLoadQueuesActions.loadFromApiFailure,
   null
);
